// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.am-card {
  display: flex;
  flex-direction: column;
  padding: 12px;
  font-family: var(--font-base);
}

.am-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 16px;
  padding: 12px;
  text-decoration: none;
  color: inherit;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.am-head:hover {
  background-color: #F8FAFC;
}

.am-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background-color: #EFF3FE;
  color: #4F378A;
  border-radius: 50%;
  font-weight: 600;
  font-size: 18px;
  flex-shrink: 0;
  overflow: hidden;
}

.am-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.am-id {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  text-align: center;
}

.am-name {
  font-family: var(--font-base);
  font-size: 16px;
  font-weight: 700;
  color: var(--dotore-ink);
  letter-spacing: 0.16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.am-role {
  font-family: var(--font-base);
  font-size: 12px;
  font-weight: 400;
  color: var(--dotore-ink-2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.am-arrow {
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  color: #747F8F;
  font-size: 18px;
  flex-shrink: 0;
}

.am-divider {
  height: 1px;
  background-color: #E4E8EF;
  margin: 8px 0;
}

.am-link {
  display: block;
  padding: 12px;
  font-family: var(--font-base);
  font-size: 14px;
  font-weight: 400;
  color: var(--dotore-ink);
  text-decoration: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.am-link:hover {
  background-color: #F8FAFC;
}

.am-link.am-logout {
  font-size: 16px;
  color: var(--dotore-ink);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AccountMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".am-card {\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  font-family: var(--font-base);\n}\n\n.am-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  gap: 16px;\n  padding: 12px;\n  text-decoration: none;\n  color: inherit;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.am-head:hover {\n  background-color: #F8FAFC;\n}\n\n.am-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background-color: #EFF3FE;\n  color: #4F378A;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 18px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.am-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.am-id {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  max-width: 100%;\n  text-align: center;\n}\n\n.am-name {\n  font-family: var(--font-base);\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--dotore-ink);\n  letter-spacing: 0.16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.am-role {\n  font-family: var(--font-base);\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--dotore-ink-2);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.am-arrow {\n  position: absolute;\n  top: 50%;\n  right: 18px;\n  transform: translateY(-50%);\n  color: #747F8F;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.am-divider {\n  height: 1px;\n  background-color: #E4E8EF;\n  margin: 8px 0;\n}\n\n.am-link {\n  display: block;\n  padding: 12px;\n  font-family: var(--font-base);\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--dotore-ink);\n  text-decoration: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.am-link:hover {\n  background-color: #F8FAFC;\n}\n\n.am-link.am-logout {\n  font-size: 16px;\n  color: var(--dotore-ink);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
